import BaseService from "@/boot/BaseService";
class ProtheusPresupuestoService extends BaseService {
  constructor() {
    super(null, "/protheus-presupuestos");
  }
  async store(id) {
    return await this.post("/", {id});
  }
}

export default new ProtheusPresupuestoService();
